module.exports = __webpack_public_path__ + "img/new image - kncyu.28487717.jpg";